import { useState } from 'react'
import PropTypes from 'prop-types'
import { motion } from 'framer-motion'

SmoothImage.propTypes = {
  duration: PropTypes.number,
  ease: PropTypes.string,
  onLoad: PropTypes.func
}

SmoothImage.defaultProps = {
  duration: 0.25,
  ease: 'easeIn'
}

export default function SmoothImage (props) {
  const [loaded, setLoaded] = useState(false)

  const variants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: props.duration,
        ease: props.ease
      }
    }
  }

  const handleLoad = () => {
    if (props.onLoad) props.onLoad()

    setLoaded(true)
  }

  return (
    <motion.img { ...props }
      variants={ variants }
      initial="hidden"
      animate={ loaded ? 'show' : 'hidden' }
      onLoad={ handleLoad } />
  )
}
